export class TechErrorDialogModel {
  title?: string;
  content?: string;
  status?: number;
  message?: string;
  code?: string;
  error?: error;
  name?: string;
  statusText?: string;
  url?: string;
}

export class error {
  Message?: string;
  ExceptionMessage?: string;
  ExceptionType?: string;
  StackTrace?: string;
  ExceptionCode?:string;
  UID?:string;
}
